import { ViewportInstance } from "./ViewportInstance";
import { BitmapText, Text, SplitText, Rectangle, Container } from "pixi.js";
import { mousePos } from "../screens/default";
import {CartoonTextFilter} from '../assets/filters/CartoonTextFilter'
import { DropShadowFilter, OutlineFilter } from "pixi-filters";
import {gsap} from 'gsap';
import { app, mobileView , mainContainer,} from "../app";

gsap.registerPlugin(SplitText);

export enum textAnimations {
    none,
    wave,
}

type viewportTextVariables = {
    destContainer: Container,
    content: string,
    size: number,
    textAnimation: textAnimations,
    perX?: number,
    perY?: number,
    minWidth?: number| undefined,
    minHeight?: number | undefined,
    maxWidth?: number | undefined,
    maxHeight?: number | undefined,
    clickFunction?: () => void
}

export class ViewportText extends ViewportInstance {

    private content: string = "undefined";
    private bitmapText: SplitText | undefined;
    private size: number;

    private filter: CartoonTextFilter;
    private shadowFilter: DropShadowFilter | undefined;
    private textAnimation: textAnimations;

    
    
    
    constructor(
            {
                destContainer,
                content,
                size,
                textAnimation,
                perX,
                perY,
                minWidth,
                minHeight,
                maxHeight,
                maxWidth,
                clickFunction,
            } : viewportTextVariables
        )
        {
        super(destContainer);
        this.content = content;
        this.perX = perX ?? 0.5;
        this.perY = perY ?? 0.5;
        this.destX = perX ?? 0.5;
        this.destY = perY ?? 0.5;
        this.size = size ?? 60;
        super.minWidth = minWidth ?? undefined;
        super.minHeight = minHeight ?? undefined;
        super.maxWidth = maxWidth ?? undefined;
        super.maxHeight = maxHeight ?? undefined;
        this.textAnimation = textAnimation;

        super.clickFunction = clickFunction;

        console.log(this.content+" : "+(-this.perX+0.5))
        this.filter = new CartoonTextFilter({
            thickness: 2
        }); 

        this.attachText(size);    
        
        super.init(); //do last
    }

    updatePixel(): void {
        super.updatePixel();
        if (this.attachment) {
            this.attachment.x = super.x;
            this.attachment.y = super.y;
        }
    }

    /**
     * Text configuration
     * @param size 
     */
    attachText(size: number) {
        //main text config
        this.attachment = new SplitText({
            text: this.content,
            style: {
            fontFamily: 'Linotte-Semibold',
            fontSize: size * 2,
            fill: 'black',
            wordWrap: true,
            wordWrapWidth: mainContainer.width + 10,
            letterSpacing: 2,
            align: 'center',
            padding: 10,
            },
            alpha: 1,
            autoSplit: true,
        });  

        this.updateText();

        // super.attachment = this.bitmapText

        this.addChild(this.attachment)
        
        if (this.textAnimation === textAnimations.wave) {
            this.createWaveAnimation();
        }
        
    }

    updateText(){

        
        if (this.attachment === undefined ) return;
        

        this.attachment.pivot.set(0,0)
        this.attachment.boundsArea = null as unknown as Rectangle;
        this.attachment?.split();

        const bounds = this.attachment.getLocalBounds();
        
        this.attachment.pivot.set(
            bounds.x + bounds.width * 0.5,
            bounds.y + bounds.height * 0.5
        );

        const r = app.renderer.resolution;

        this.attachment.filterArea = new Rectangle(
             bounds.x * r,
             (bounds.y) * r,
             bounds.width,
             (bounds.height)
        );
        
        this.resize();
    }

    /**
     * Wave animation
     * @returns 
     */
    createWaveAnimation() {
        const waveTimeline = gsap.timeline({ 
            repeat: -1, //inf
            yoyo: false,
            repeatDelay: 0.0
        });
        
        const waveHeight = 17; // How much characters move
        const characterDelay = 0.3; // Delay between each character
        const duration = 2.5; // Duration of each wave cycle
        
        // this.bitmapText!.y = -waveHeight;

        (this.attachment as SplitText).chars.forEach((char, index) => {


            const delay = index * characterDelay;
            // Move up
            waveTimeline.to(char, {
                y: `-=${waveHeight}`,
                duration: duration / 2,
                ease: "sine.inOut"
            }, delay);
            // Move back
            waveTimeline.to(char, {
                y: `+=${waveHeight}`,
                duration: duration / 2,
                ease: "sine.inOut"
            }, delay + (duration / 2));
        });
        
        return waveTimeline;
    }


    

}